__turbopack_context__.v({
  "arrow": "index-module__aXclYq__arrow",
  "arrowRotated": "index-module__aXclYq__arrowRotated",
  "collapse": "index-module__aXclYq__collapse",
  "content": "index-module__aXclYq__content",
  "customItem": "index-module__aXclYq__customItem",
  "disabled": "index-module__aXclYq__disabled",
  "dropdown": "index-module__aXclYq__dropdown",
  "dropdownExit": "index-module__aXclYq__dropdownExit",
  "editorSelect": "index-module__aXclYq__editorSelect",
  "expand": "index-module__aXclYq__expand",
  "loading": "index-module__aXclYq__loading",
  "loadingIcon": "index-module__aXclYq__loadingIcon",
  "loadingText": "index-module__aXclYq__loadingText",
  "open": "index-module__aXclYq__open",
  "option": "index-module__aXclYq__option",
  "optionContent": "index-module__aXclYq__optionContent",
  "optionDescription": "index-module__aXclYq__optionDescription",
  "optionIcon": "index-module__aXclYq__optionIcon",
  "optionLabel": "index-module__aXclYq__optionLabel",
  "optionLabelWithDescription": "index-module__aXclYq__optionLabelWithDescription",
  "optionText": "index-module__aXclYq__optionText",
  "optionTextWithDescription": "index-module__aXclYq__optionTextWithDescription",
  "selectContainer": "index-module__aXclYq__selectContainer",
  "spin": "index-module__aXclYq__spin",
});
